import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EmsServicesService } from '../../../services/ems-services.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
interface approvalFlow {
  approvalCount: any;
  EmpLavel: any;
  EmpPosition: any;
}
@Component({
  selector: 'app-create-quick-code',
  templateUrl: './create-quick-code.component.html',
  styleUrls: ['./create-quick-code.component.css'],
})
export class createQuickCodeComponent {
  products: approvalFlow[] = [
    {
      approvalCount: null,
      EmpLavel: null,
      EmpPosition: null,
    },
  ];
  quickCagetgory = [
    {
      id: 1,
      name: 'Category 1',
    },
    {
      id: 2,
      name: 'Category 2',
    },
    {
      id: 3,
      name: 'Category 3',
    },
  ];

  createForm = new FormGroup({
    category: new FormControl(null, Validators.required),
    name: new FormControl('', Validators.required),
    status: new FormControl(null, Validators.required),
  });
  quickCodeCategoryList: any;
  editTrue: any;
  EditData: any;
  statusOptions = [
    { value: 1, label: 'Active' },
    { value: 0, label: 'Inactive' },
  ];
  addFromAnotherComponent:any;
  constructor(private emsServices: EmsServicesService,public dialogRef: DynamicDialogRef,public data: DynamicDialogConfig
    , public messageService: MessageService
  ) {
    this.quickCodeCategoryList = data.data.quickCodeCategoryList
    this.addFromAnotherComponent = data.data.addFromAnotherComponent
    this.editTrue =data?.data?.edit
    if(data && data?.data && data?.data?.editData && data?.data?.edit){
      this.EditData = data?.data?.editData[0]
      this.createForm.patchValue({
        category: this.EditData?.categoryId,
        name: this.EditData?.name,
        //  expenseModeId: this.EditData?.expenseModeId,
        status: this.EditData?.status
      });
    }
    if(this.addFromAnotherComponent){
      this.EditData = data?.data?.editData[0]
      this.createForm.patchValue({
        category: this.EditData?.categoryId,
        status: this.EditData?.status
     });
    }
  }

  ngOnInit(): void {
  }



  submitForm() {
    let payload: any = {
      "categoryId": this.createForm.value.category,
      "name": this.createForm.value.name,
      "status": this.createForm.value.status,
    };
    if (this.editTrue) {
      payload.id = this.EditData.id;
    }
    this.dialogRef.close('data')
    this.emsServices.addQuickCode(payload).subscribe((data: any) => {
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Quick code added successfully' });

      this.dialogRef.close(data)
      
    });
  }
}
